// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1Jj29","path":"_6HZU2"};